export default "__VITE_ASSET__BfokNj8d__"